import { useParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';

export const useGetContentDetailCodeList = () => {
  const { contentCode } = useParams();
  const processFormData = useBoundStore((state) => state.hsptlzForm.processFormData);
  const contents = processFormData[contentCode];

  return contents.contentDetailCodeList;
};
